import {LovValueSummary} from './lovValueSummary.model';

export class LovValueOrCustomValueModel {
    lovValue: LovValueSummary;
    customValue: string;

    get label(): string {
        return this.lovValue ? this.lovValue.label : this.customValue;
    }

    get value(): string {
        return this.lovValue ? this.lovValue.value : this.customValue;
    }
}
